import { ItemLabel } from 'app/providers/storage-api/object-label.service';
import { ObjectLabel } from '../../../providers/storage-api/object-label.service';

export function mapObjectLabelsToProjectItemLabels(
  objectLabels: ObjectLabel[]
): Partial<ItemLabel>[] {
  if (!objectLabels) {
    return [];
  }

  return objectLabels.map((label) => {
    let tooltip: string | undefined = undefined;
    if ((label as ObjectLabel).label.length > 20) {
      tooltip = (label as ObjectLabel).label;
    }
    return { ...label, type: 'user', tooltip };
  });
}
